import { ChBetterDocSearchDialog } from "@/modules/patients/detail/better-doc/ch/ch-better-doc-search-dialog"
import { DeBetterDocSearchDialog } from "@/modules/patients/detail/better-doc/de/de-better-doc-search-dialog"
import { useCountryParam } from "@/modules/patients/hooks/useCountryParam"

type BetterDocSearchDialogProps = {
  onClose: () => void
}

export const BetterDocSearchDialog = ({ onClose }: BetterDocSearchDialogProps) => {
  const country = useCountryParam()

  if (country === "CH") {
    return <ChBetterDocSearchDialog onClose={onClose} />
  }

  if (country === "DE") {
    return <DeBetterDocSearchDialog onClose={onClose} />
  }

  return null
}
